// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const USER_STROLLERS_DELETE_CONFIRM = "Naozaj chce\u0161 zmaza\u0165 ko\u010d\u00edk zo svojho profilu?";
